import { openWixBlocks } from './wixBlocksConsumerActions';

const actions = {
  openWixBlocks,
};

export { actions };
